import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default class extends Controller {
  connect() {
    this.datepicker = flatpickr(this.element, this.flatpickrConfig());
  }


  flatpickrConfig() {
    const date = new Date();
    const maximumDate = new Date(date.getFullYear(), date.getMonth() + 0);

    return {
      mode: "multiple",
      maxDate: maximumDate,
      allowInput: false,
      altInput: true,
      sort: true,
      defaultDate: this.element.value ? this.element.value.split(" ") : [],
      plugins: [
        new monthSelectPlugin({
          allowInput: false,
          dateFormat: "Y-m-d",
          altFormat: "M Y",
        }),
      ],
    };
  }
}
